import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

const SITE = process.env.REACT_APP_BACKEND_URL;
const NAME = "The House of Trading";

export const Seo = ({ title, description, type = "website", image = `${SITE}/logo-dark.png`, schema, noindex }) => {
  const { pathname } = useLocation();
  const url = `${SITE}${pathname}`;
  const full = title ? title : `${NAME} | Stock Market & Trading Academy in Mohali`;
  const schemas = Array.isArray(schema) ? schema : schema ? [schema] : [];
  return (
    <Helmet>
      <title>{full}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex,nofollow" />}
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={NAME} />
      <meta property="og:title" content={full} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      {image && <meta property="og:image" content={image} />}
      <meta name="twitter:card" content={image ? "summary_large_image" : "summary"} />
      <meta name="twitter:title" content={full} />
      <meta name="twitter:description" content={description} />
      {schemas.map((s, i) => <script key={i} type="application/ld+json">{JSON.stringify(s)}</script>)}
    </Helmet>
  );
};

export const orgSchema = (s) => ({
  "@context": "https://schema.org", "@type": ["Organization", "EducationalOrganization", "LocalBusiness"],
  name: NAME, url: SITE, logo: `${SITE}/logo-dark.png`, telephone: s?.phone, email: s?.email,
  address: { "@type": "PostalAddress", streetAddress: s?.address_line1, addressLocality: s?.city, addressRegion: s?.state, postalCode: s?.postal_code, addressCountry: "IN" },
  geo: s?.geo ? { "@type": "GeoCoordinates", latitude: s.geo.lat, longitude: s.geo.lng } : undefined,
  openingHours: "Mo-Sa 09:00-19:00", sameAs: [s?.instagram, s?.facebook, s?.linkedin, s?.youtube].filter(Boolean),
});

export const courseSchema = (c) => ({
  "@context": "https://schema.org", "@type": "Course", name: c.title, description: c.tagline, url: `${SITE}/programs/${c.slug}`,
  provider: { "@type": "Organization", name: NAME, sameAs: SITE }, educationalLevel: c.level,
  hasCourseInstance: { "@type": "CourseInstance", courseMode: (c.mode || []).join(", "), location: c.location },
});

export const faqSchema = (faqs) => ({
  "@context": "https://schema.org", "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({ "@type": "Question", name: f.q, acceptedAnswer: { "@type": "Answer", text: f.a } })),
});

export const breadcrumbSchema = (items) => ({
  "@context": "https://schema.org", "@type": "BreadcrumbList",
  itemListElement: items.map((it, i) => ({ "@type": "ListItem", position: i + 1, name: it.name, item: `${SITE}${it.path}` })),
});

export const articleSchema = (a) => ({
  "@context": "https://schema.org", "@type": "Article", headline: a.title, description: a.meta_description,
  author: { "@type": "Organization", name: a.author }, publisher: { "@type": "Organization", name: NAME },
  datePublished: a.published_at, dateModified: a.updated_at, mainEntityOfPage: `${SITE}/blog/${a.slug}`,
});
